import { appendReduxPart } from "infrastructure/store";

import SecurityRoleMembers from "./SecurityRoleMembers";
import { securityRoleMembersSaga } from "./SecurityRoleMembers.saga";
import { securityRoleMembers } from "./SecurityRoleMembers.slice";

export * from "./SecurityRoleMembers.actions";
export * from "./SecurityRoleMembers.state";

export { SecurityRoleMembers };

appendReduxPart(
  {
    reducerName: securityRoleMembers.name,
    reducer: securityRoleMembers.reducer
  },
  securityRoleMembersSaga()
);
